import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  intro?: string;
  align?: 'center' | 'left';
  tone?: 'dark' | 'light';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  intro,
  align = 'center',
  tone = 'dark'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto items-center' : 'text-left items-start';
  const titleColor = tone === 'dark' ? 'text-ink' : 'text-cream';
  const bodyColor = tone === 'dark' ? 'text-muted' : 'text-cream/80';
  const eyebrowColor = tone === 'dark' ? 'text-clay' : 'text-cream/70';
  return <div className={`flex max-w-3xl flex-col ${alignment}`} data-id="element-124" data-mp="1tip7xlr7spf">
      {eyebrow && <span className={`mb-4 text-sm font-bold uppercase tracking-[0.2em] ${eyebrowColor}`} data-id="element-125" data-mp="6svc2icmkzs0">
          {eyebrow}
        </span>}
      <h2 className={`font-display text-3xl font-medium leading-tight sm:text-4xl lg:text-5xl ${titleColor}`} data-id="element-126" data-mp="uhelj17evilo">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 font-display text-xl italic sm:text-2xl ${bodyColor}`} data-id="element-127" data-mp="1tah63l1jub5p">
          {subtitle}
        </p>}
      {intro && <p className={`mt-6 text-lg leading-relaxed sm:text-xl ${bodyColor}`} data-id="element-128" data-mp="22ziil18vyaex">{intro}</p>}
    </div>;
}